import React, { useContext, useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ImageComponent from 'atoms/Image';
import { ButtonComp } from 'atoms/Buttons';
import { UserOrderContext } from 'context/context';
import {
  getValueOrDefaultObject,
  getDispositionTypeOnAPIFormat,
  getTernaryValue,
  createBasketData,
  isEmptyObject,
  isEmptyEvery,
  toastifyFn,
  isMobileDevice,
  manipulateAlreadySearchedLocations,
  setSearchStoreByAtrribute,
} from 'common/utilities/utils';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { AUTO_DETECT_CONSTANTS, MODAL_MSG_CONSTANTS } from '../Constants/AutoDetectionConstants';
import { ChannelManager } from 'common/manager';
import geoLocation from '@kfc-global/react-shared/utils/geoLocation.js';
import {
  checkStoresWithDistance,
  filterStatusCallResponse,
  setNewDisposition,
  getToastMessage,
  updateCurrentStoreInfo,
  displayMsgAfterPickUpAndDineIn,
  getCurrentLocationGlobal,
  clearDisposition,
  checkNearBystoresData,
} from '../SearchStoreUtilities/AutoDetectionUtils';
import SCHEDULE_ORDER_SAMPLE_DATA from 'organisms/ScheduleOrder/Data/SampleData';
import {
  setGeoHashCount,
  getBulkStoreStatus,
  getUserLocationAccess,
} from '@kfc-global/react-shared/redux/Actions/StoresAction';
import { createBasketsAction, qrCodeScanTimeAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { setUserParams } from '@kfc-global/react-shared/redux/Actions/AppStateAction';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ModalComponent from 'molecules/Modal';
import LocalizationChangeModal from './LocalizationChangeModal';
import SearchPin from 'styles/staticAssets/images/Search_Pin.svg';
import { DISPOSITIONNEW } from 'common/constants/SharedConstants';
import { getDistanceFromGoogleMatrix } from '../SearchStoreUtilities/geoUtils';
import { localisationStartAnalytics } from 'common/utilities/analyticsUtils';
import SEARCH_STORE_CONSTANTS from 'organisms/SearchStore/Constants/SearchStoreConstants';

const errorMessageOnStoreNotFound = params => {
  const { validateNearBystoreResponse, autoDetectFlow, allStores, count, currentCount, autodetectDistance, PICK_UP } =
    params;
  if (autoDetectFlow && allStores.length >= 0 && count === currentCount) {
    validateNearBystoreResponse(allStores, autodetectDistance, PICK_UP);
  }
};

export const AutoDetectionBanner = props => {
  const { autodetectDistance } = props;
  const [userLocation, setUserLocation] = useState({});
  const [activeDisposition, setActiveDisposition] = useState('');
  const [storeTiming, setStoreTiming] = useState('');
  const [activeDistance, setActiveDistance] = useState(null);
  const [autoDetectFlow, setAutoDetectFlow] = useState(false);
  const [isPickupOrDineIn, setIsPickupOrDineIn] = useState(false);
  const [closedStore, setClosedStore] = useState(false);
  const [noStore, setNoStore] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [eligibleStore, setEligibleStore] = useState({});
  const [localizationChange, setLocalizationChange] = useState(false);
  const [isCurrentlyClosed, setIsCurrentlyClosed] = useState(false);
  const { userOrderStateDispatch, userOrderState } = useContext(UserOrderContext);
  const { autoDetectionClicked } = userOrderState;
  const { timingsSampleData = {} } = SCHEDULE_ORDER_SAMPLE_DATA;
  const dispatch = useDispatch();
  const {
    allStores = [],
    storesWithStatus = [],
    storesSatusError,
    count,
    currentCount,
    userLocationAccessStatus,
  } = useSelector(data => getValueOrDefaultObject(data.storesReducer));
  const profileReducer = useSelector(data => data.profileReducer);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { storeSearch = {}, tenantId } = useSelector(data => getValueOrDefaultObject(tenantReducer));
  const { maxDriveTimeMins, distanceMetrics, geohashprecision, boundingBoxSizeMeters } = storeSearch;
  const {
    AUTO_DETECTION_BUTTON_FLAG,
    LOCATION_BLOCK_BANNER,
    DINE_IN,
    PICK_UP,
    DELIVERY,
    DISTANCE_7500MR,
    DISTANCE_20000MR,
    BLOCKED,
    GRANTED,
    SET_LOCATION_BUTTON,
  } = AUTO_DETECT_CONSTANTS;
  const { SCHEDULE_ORDER_DATA = '' } = START_ORDER_CONSTANTS;
  const { DELIVERY_TOAST_MSG, SET_LOCATION_TEXT } = MODAL_MSG_CONSTANTS;
  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem(DISPOSITIONNEW))
    : userOrderState.dispositionNew;

  let userParams = useSelector(data => data.appStateReducer.userStatus);
  const foodLines = useSelector(data => data?.cartReducer?.cartData?.foodLines);

  const SetLocationClickHandler = () => {
    localisationStartAnalytics();
    userOrderStateDispatch({ type: AUTO_DETECTION_BUTTON_FLAG, value: { autoDetectionClicked: true } });
  };

  useEffect(() => {
    if (autoDetectionClicked && !foodLines?.length) {
      setAutoDetectFlow(true);
      let getUserLocation = async () => {
        await getCurrentLocation();
      };
      window.navigator.geolocation?.getCurrentPosition(
        () => {
          dispatch(getUserLocationAccess(GRANTED));
          getUserLocation();
        },
        error => {
          if (userLocationAccessStatus !== GRANTED) {
            userOrderStateDispatch({ type: LOCATION_BLOCK_BANNER, value: { showLocationBlockBanner: true } });
            setTimeout(() => {
              userOrderStateDispatch({ type: LOCATION_BLOCK_BANNER, value: { showLocationBlockBanner: false } });
            }, 3000);
            setAutoDetectFlow(false);
          }
          dispatch(getUserLocationAccess(BLOCKED));
        },
      );
      userOrderStateDispatch({ type: AUTO_DETECTION_BUTTON_FLAG, value: { autoDetectionClicked: false } });
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoDetectionClicked]);

  const getCurrentLocation = useCallback(async () => {
    const results = await getCurrentLocationGlobal();
    if (results) {
      const { longitude, latitude } = ChannelManager.coordinates;
      setUserLocation({ userLat: latitude, userLong: longitude });
      getNearbyStores(latitude, longitude);

      //Test data
      // setUserLocation({ userLat: 11.2587531, userLong:  75.78041});
      // getNearbyStores(11.2587531,  75.78041);

      userOrderStateDispatch({
        type: SCHEDULE_ORDER_DATA,
        value: {
          deliveryAddress: ChannelManager.address,
          //Test data
          //deliveryAddress:"Bank Road, Tazhekkod, Kozhikode 673001, Kerala Tazhekkod Kozhikode India"
        },
      });
      manipulateAlreadySearchedLocations(ChannelManager.address, SEARCH_STORE_CONSTANTS.ALREADY_SERACHED_LOCATIONS);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userOrderStateDispatch]);

  const getNearbyStores = (lat, lon) => {
    const calculateGHPayload = {
      lat: lat,
      lon: lon,
      distanceFromCurrentLoc: boundingBoxSizeMeters / 1000,
      geohashprecision: geohashprecision,
    };
    const geoHash = geoLocation.calculateGH(calculateGHPayload);
    dispatch(setGeoHashCount(geoHash?.length));
  };

  useEffect(() => {
    errorMessageOnStoreNotFound({
      validateNearBystoreResponse,
      autoDetectFlow,
      allStores,
      count,
      currentCount,
      autodetectDistance,
      PICK_UP,
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allStores, currentCount]);

  useEffect(() => {
    autoDetectFlow &&
      storesWithStatus.length > 0 &&
      filterStatusCallResponse(
        storesWithStatus,
        getLocalized,
        setAutoDetectFlow,
        setClosedStore,
        activeDistance,
        activeDisposition,
        userLocationAccessStatus,
        userParams.localized,
        setLocalizationChange,
        checkStoresForNextDisposition,
        setEligibleStore,
        setIsCurrentlyClosed,
      );
    autoDetectFlow &&
      storesWithStatus.length > 0 &&
      setStoreTiming(storesWithStatus[0]?.summary?.timings?.operatingHours[0]?.availableHours);
    autoDetectFlow && storesSatusError && !userParams.localized && setClosedStore(true);
    autoDetectFlow && storesSatusError && userParams.localized && setLocalizationChange(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storesWithStatus, storesSatusError]);

  const validateNearBystoreResponse = (allStoresData, maxDistance, dispositionType) => {
    setActiveDisposition(dispositionType);
    setActiveDistance(maxDistance);
    const validatedNearBystoresData = checkNearBystoresData(allStoresData);
    //calculate linear Distance
    const linearDistancePayload = {
      stores: validatedNearBystoresData,
      disposition: dispositionType,
      distanceMetrics: distanceMetrics,
      driveTime: maxDriveTimeMins,
      distanceInMtrs: maxDistance,
      noOfStores: validatedNearBystoresData.length,
      channel: ChannelManager.channel,
    };

    const storesWithLinearDistance = geoLocation.checkAndProceed(linearDistancePayload);

    const autoDetectLastSearchedData = {
      dispositionType: dispositionType,
      maxDistance: maxDistance,
      storesWithLinearDistance: storesWithLinearDistance,
    };
    dispositionType.toUpperCase() === 'DELIVERY' &&
      sessionStorage.setItem('autoDetectLastSearchedData', JSON.stringify(autoDetectLastSearchedData));
    checkStoresWithDistance(
      storesWithLinearDistance,
      dispositionType,
      maxDistance,
      checkStoresForNextDisposition,
      callStatusAPI,
      googleDistanceAPI,
    );
  };

  const checkStoresForNextDisposition = (dispositionType, maxDistance) => {
    if (maxDistance === autodetectDistance) {
      if (dispositionType === PICK_UP) {
        validateNearBystoreResponse(allStores, autodetectDistance, DINE_IN);
      } else if (dispositionType === DINE_IN) {
        validateNearBystoreResponse(allStores, autodetectDistance, DELIVERY);
      } else {
        validateNearBystoreResponse(allStores, DISTANCE_7500MR, DELIVERY);
      }
    } else if (maxDistance === DISTANCE_7500MR) {
      if (dispositionType === DELIVERY) {
        validateNearBystoreResponse(allStores, DISTANCE_20000MR, PICK_UP);
      }
    } else if (maxDistance === DISTANCE_20000MR) {
      if (dispositionType === PICK_UP) {
        validateNearBystoreResponse(allStores, DISTANCE_20000MR, DINE_IN);
      } else {
        //No nearby stores available or closed
        if (userParams.localized) {
          setLocalizationChange(true);
        } else if (isCurrentlyClosed) {
          setClosedStore(true);
        } else {
          setNoStore(true);
        }
        setAutoDetectFlow(false);
      }
    }
  };
  const callStatusAPI = (storeList, serviceType) => {
    const dataList = storeList?.map(store => {
      return { storeId: store.id, channel: ChannelManager.channel, service: serviceType };
    });
    const statusCallPayload = {
      data: dataList,
      store: storeList,
      tenantId: tenantId,
      setStatusFlag: false,
      isFavoritePage: false,
    };
    dispatch(getBulkStoreStatus(statusCallPayload));
  };

  const googleDistanceAPI = origin => {
    let originCoordinates = [];
    origin?.forEach(element => {
      originCoordinates.push({ lat: element.location?.latitude, lng: element.location?.longitude });
    });
    getDistanceFromGoogleMatrix(
      originCoordinates,
      [{ lat: userLocation.userLat, lng: userLocation.userLong }],
      getGoogleApiResponse,
    );
  };

  const getGoogleApiResponse = ({ allStoreDistance, originAddressText }) => {
    const autoDetectLastSearchedData = JSON.parse(sessionStorage.getItem('autoDetectLastSearchedData'));
    const { dispositionType = '', maxDistance = '', storesWithLinearDistance = [] } = autoDetectLastSearchedData;
    const serviceType = getDispositionTypeOnAPIFormat(dispositionType?.toUpperCase());

    //merge getGoogleApiResponse with nearBystores
    const googleApiMergedStores = mergeStoreData(allStoreDistance, storesWithLinearDistance);

    //sort the merged stores
    const getSortedNearbyStoresPayload = {
      stores: googleApiMergedStores,
      numberOfStores: googleApiMergedStores.length,
      disposition: serviceType,
      distanceMetrics: distanceMetrics,
      driveTime: maxDriveTimeMins,
      channel: ChannelManager.channel,
    };
    const sortedNearBystores = geoLocation.getSortedNearbyStores(getSortedNearbyStoresPayload);
    sessionStorage.removeItem('autoDetectLastSearchedData');
    if (sortedNearBystores?.length) {
      callStatusAPI(sortedNearBystores, serviceType);
    } else {
      checkStoresForNextDisposition(dispositionType, maxDistance);
    }
  };

  const mergeStoreData = (storeDataOne, storeDataTwo) => {
    const mergedStores = storeDataTwo?.map((storeTwo, index) => {
      return { ...storeTwo, distance: storeDataOne[index] };
    });
    return mergedStores;
  };

  const getLocalized = async finalStore => {

    let dateTimeObj = {
      time: 'ASAP',
      interval: finalStore.summary.timings.scheduled.periods[0]?.interval,
      date: new Date(),
      selectedTime: 'ASAP',
    };
    if (
      dispositionNew === null ||
      dispositionNew.type !== activeDisposition ||
      dispositionNew.store.id !== finalStore.id ||
      dispositionNew.deliveryAddress !== userOrderState?.scheduleOrderData?.deliveryAddress
    ) {
      let obj = await createBasketData(
        finalStore,
        getDispositionTypeOnAPIFormat(activeDisposition),
        profileReducer.customerId,
        dateTimeObj,
        activeDisposition === DELIVERY ? userOrderState?.scheduleOrderData?.deliveryAddress : undefined,
        activeDisposition === DELIVERY ? userOrderState?.scheduleOrderData?.deliveryAddressLine : undefined,
      );
      dispatch(qrCodeScanTimeAction(''));
      dispatch(createBasketsAction({ data: obj, tenantId: tenantId }));
    }
    setNewDisposition(
      dispositionNew,
      userOrderStateDispatch,
      userOrderState,
      activeDisposition,
      finalStore,
      dateTimeObj,
    );

    let store = getTernaryValue(finalStore, finalStore, null);
    dispatch(
      setUserParams({
        ...userParams,
        localized: true,
      }),
    );

    updateCurrentStoreInfo(userOrderStateDispatch, activeDisposition, dateTimeObj, store, tenantReducer);

    if (activeDisposition === DINE_IN || activeDisposition === PICK_UP) {
      setIsPickupOrDineIn(true);
    } else {
      toastifyFn(translateWithI18Next(DELIVERY_TOAST_MSG));
    }
    setAutoDetectFlow(false);
    setSearchStoreByAtrribute();
  };
  const gotoMenuPage = (closedStore = false, noStore = false) => {
    props.history.push({
      pathname: `${START_ORDER_CONSTANTS.MENU_URL}`,
    });
    let message = getToastMessage(
      isPickupOrDineIn,
      closedStore,
      noStore,
      activeDisposition,
      storeTiming,
      setIsPickupOrDineIn,
      setNoStore,
      setClosedStore,
    );
    toastifyFn(message);
    setAutoDetectFlow(false);
    (closedStore || noStore) && clearDisposition(userOrderStateDispatch, setUserParams, dispatch, userParams);
  };

  const gotToHome = () => {
    props.history.push({
      pathname: '/',
    });
    let message = getToastMessage(
      isPickupOrDineIn,
      closedStore,
      noStore,
      activeDisposition,
      storeTiming,
      setIsPickupOrDineIn,
      setNoStore,
      setClosedStore,
    );
    toastifyFn(message);
    setAutoDetectFlow(false);
  };

  const closeModel = () => {
    setIsModalOpen(false);
    setLocalizationChange(false);
    setAutoDetectFlow(false);
  };

  const onUpdateHandler = event => {
    setIsModalOpen(false);
    isEmptyObject(eligibleStore)
      ? getLocalized(eligibleStore)
      : (( isCurrentlyClosed
      && setClosedStore(true) )
      || setNoStore(true) );
    setLocalizationChange(false);
    setAutoDetectFlow(false);
  };

  const modalProps = {
    id: 'welcomeBackModal',
    role: 'dialog',
    modalTitleId: 'welcomeBackModal',
    show: true,
    classNames: `Base-modal ${getTernaryValue(
      isMobileDevice(window.innerWidth),
      'localization-change-mobile-modal',
      'localization-change-modal',
    )}`,
    showCloseBtn: true,
    showBackBtn: false,
    closeButtonHandler: closeModel,
    modalTitle: '',
    modalTitleRequired: false,
    closeDataTestId: 'close-modal',
    autoFocus: true,
  };

  const showBanner = useCallback(() => {
    return (userLocationAccessStatus !== GRANTED || (userLocationAccessStatus === GRANTED && !userParams.localized))
  }, [userLocationAccessStatus, userParams.localized, GRANTED]);

  return (
    <>
      {showBanner() && (
        <div id='kfc-banner-image' className='setLocationData' data-testid='banner-setLocation'>
          <ImageComponent data-testid='' srcFile={SearchPin} alt={'location-map'} className='google-location-img' />
          <div className='setLocationText'>{translateWithI18Next(SET_LOCATION_TEXT)}</div>
          <ButtonComp
            className={`button  whiteButton blackBorder setLocation-button setLocation-button-in`}
            data-testid='set-location-button'
            onClickHandler={SetLocationClickHandler}
          >
            {SET_LOCATION_BUTTON}
          </ButtonComp>
        </div>
      )}
      <hr role='presentation' className='setLocationdivider' />
      {displayMsgAfterPickUpAndDineIn(
        gotoMenuPage,
        gotToHome,
        isPickupOrDineIn,
        closedStore,
        noStore,
        activeDisposition,
        dispositionNew,
        userOrderStateDispatch,
        setUserParams,
        dispatch,
        userParams,
      )}
      {isModalOpen && localizationChange && (
        <ModalComponent {...modalProps}>
          <LocalizationChangeModal onCancel={closeModel} updateHandler={onUpdateHandler} />
        </ModalComponent>
      )}
    </>
  );
};
